import React, { useState } from 'react';
import { supabase } from '../services/supabase/supabase-config';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Card from '../components/ui/Card';
import Button from '../components/ui/Button';
import Alert from '../components/ui/Alert';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrorMessage('');
    setSuccessMessage('');

    if (!email) {
      setErrorMessage('Por favor, preencha o campo com um email válido.');
      return;
    }

    setLoading(true);
    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/reset-password`,
      });

      if (error) {
        setErrorMessage(error.message);
      } else {
        setSuccessMessage('Instruções para redefinir sua senha foram enviadas para seu email.');
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      }
    } catch (error) {
      setErrorMessage('Ocorreu um erro desconhecido. Tente novamente mais tarde.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>Esqueci a Senha</title>
      </Helmet>

      <div className="flex items-center justify-center min-h-screen bg-rn-bg px-4">
        <Card className="w-full max-w-md p-8" hover={false}>
          <h2 className="text-2xl font-semibold text-center mb-2 text-rn-navy">Esqueceu a senha?</h2>
          <p className="text-center text-rn-text-soft mb-6">Enviaremos um email com instruções para recuperar a senha.</p>
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-rn-navy">
                Email para recuperação
              </label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={loading}
                className="mt-1 block w-full px-3 py-2 border border-rn-line rounded-md shadow-sm placeholder-rn-text-soft focus:outline-none focus:ring-2 focus:ring-rn-orange-text focus:border-rn-orange-text"
              />
            </div>
            
            {errorMessage && <Alert type="error" message={errorMessage} />}
            {successMessage && <Alert type="success" message={successMessage} />}

            <Button type="submit" className="w-full" disabled={loading} aria-label="Enviar email de verificação">
              {loading ? 'Enviando...' : 'Enviar email'}
            </Button>
          </form>
        </Card>
      </div>
    </>
  );
};

export default ForgotPassword;
